import React from 'react';
import classNames from 'classnames';

import NimaLoadingVisual from './NimaLoadingVisual';

const surfaceToneToVisualTone = {
  auto: 'brand',
  light: 'brand',
  dark: 'light'
};

/**
 * Espera central de pagina, modal ou bloco grande.
 *
 * Porte de MVF/packages/ui/src/shared/loading/NimaLoadingSurface.tsx. E este o
 * componente da tela "Carregando workspace..." da NIMA. O aria-busy fica na
 * superficie e a regiao de status interna carrega o unico texto anunciado.
 */
const NimaLoadingSurface = ({
  label = 'Carregando seus dados…',
  supportingText,
  size = 'lg',
  tone = 'auto',
  showLabel = true,
  minHeight,
  page = false,
  className,
  style,
  'aria-label': ariaLabel,
  'aria-busy': ariaBusyIgnored,
  ...props
}) => {
  const visualTone = surfaceToneToVisualTone[tone];
  const announcedLabel = ariaLabel || label;
  const surfaceStyle = Object.assign({}, style, minHeight !== undefined ? { minHeight } : {});

  return (
    <div
      {...props}
      className={classNames(
        'nima-loading-surface',
        tone === 'auto' && 'nima-loading-surface--auto',
        tone === 'dark' && 'nima-loading-surface--dark',
        page && 'nima-loading-surface--page',
        className
      )}
      style={surfaceStyle}
      aria-busy="true"
    >
      <span
        className={classNames('nima-loading-indicator', 'nima-loading-indicator--' + visualTone)}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        aria-label={ariaLabel}
      >
        <NimaLoadingVisual size={size} tone={visualTone} />
        <span className={showLabel ? 'nima-loading-indicator__label' : 'nima-sr-only'}>
          {showLabel ? (
            <React.Fragment>
              {label}
              {supportingText ? (
                <small className="nima-loading-indicator__supporting-text">{supportingText}</small>
              ) : null}
            </React.Fragment>
          ) : (
            announcedLabel
          )}
        </span>
      </span>
    </div>
  );
};

export default NimaLoadingSurface;
